<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Members</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="membersbox">
        <el-tabs type="border-card" class="xiangce">
          <el-tab-pane label="Album">
            <span slot="label">
              <i class="el-icon-picture-outline"></i> Album
            </span>
            <div class="imgListBox">
              
              <ul class="imgUl">
                <li v-for="(item,key) in imgList" :key = 'key'  >
                  <img :src='item.src' :preview="key" :preview-text="item.title"/>
                  <p class="title">{{item.title}}</p>
                  <p class="maintext">{{item.description}}</p>
                  <p class="tips"><span class="sp1"><i class="el-icon-time"></i>{{item.shoot_date}}</span></p>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import apiSign from "../assets/js/apiSign";
import "@/assets/css/opportunities.less";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
export default {
  data(){
    return {
      family:null,
      list: [
        {
          src: "https://placekitten.com/600/400",
          w: 600,
          h: 600
        },
        {
          src: "https://placekitten.com/1200/900",
          w: 1200,
          h: 900
        }
      ],
      imgList: [],
      opportunities:''
    }
  },
  mounted(){
    this.getFamilyImage();
    this.getImgList();
  },
  methods:{
    getImgList() {
      let field = { rtime: apiSign.getTime() };
      this.axios.get(this.axios.defaults.baseURL +'/yiwei/app/opportunities',{
        headers: {
            sign: apiSign.sign(field)
          },
          params: field
      }).then(resp=>{
        this.opportunities = resp.data.data.opportunities
      })
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/album/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          let respList = resp.data.data.data;
          // this.imgList = resp.data.data.data;
          let imgList = [];
          Object.keys(respList).forEach(key => {
            let imgDict = {};
            imgDict["src"] = respList[key].image;
            imgDict["title"] = respList[key].title;
            imgDict["description"] = respList[key].description;
            imgDict["shoot_date"] = respList[key].shoot_date;
            imgList.push(imgDict);
          });
          this.imgList = imgList;
          this.$previewRefresh()
        });
    },
    getFamilyImage(){
      let field = {rtime:apiSign.getTime()}
      let storageFamily = sessionStorage.getItem('family');
      if(storageFamily){
        this.family = storageFamily
      }
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/app/family",
          {
            headers:{
              sign:apiSign.sign(field)
            },
            params:field
          }
        )
        .then(resp => {
          if(resp.data.code){
            this.$message({
              type: 'error',
              message: resp.data.msg
            });
          }else{
            if ('family' in resp.data.data){
              this.family = resp.data.data.family
              sessionStorage.setItem('family', this.family)
            }else{
              this.$message({
                type: 'error',
                message: 'family照片不存在'
              });
            }
          }

        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: err
          });
        });
    }
  }
};
</script>
<style>
    .membersbox{padding: 20px;background: #fff;border-radius: 5px;text-align: center;}
    .membersbox img{width: 100%;display: inline-block;height: auto;}
    .membersbox .title{font-size: 24px;
    color: #333;
    font-weight: bold;
    margin-bottom: 25px;}
</style>

